import { API_ROUTE_TRADE_IN_ORDERS } from '@/resources/api-routes'
import { post } from '@/util/auth'

const IS_NEW_BACKEND_API = true

export const sendTradeInPriceRequest = async (payload: { assetId: string; partnerId?: string }) =>
  post<null>(API_ROUTE_TRADE_IN_ORDERS, payload, IS_NEW_BACKEND_API)
